export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9120.5a3ded06.jpg";